import React from 'react';
import BobjectTableContainer from './bobjectTable.container';

const ViewBobjectTableContainer = props => <BobjectTableContainer viewActions {...props} />;

export default ViewBobjectTableContainer;
